import type { ActivityModule } from '../../core/activity';
import { mountOrderingNumbers } from './ui';
import levelsData from './levels.json';
import './style.css';

export const orderingNumbers: ActivityModule = {
  id: 'ordering_numbers',
  title: 'Ordenar números',
  description: 'Coloque os números em ordem crescente ou decrescente. Clique no próximo da sequência.',
  ageMin: 5,
  ageMax: 9,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/ordering_numbers/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountOrderingNumbers,
};
